import { useState } from 'react';
import { X, Mail, Send, Loader } from 'lucide-react';
import axios from 'axios';
import { API_URL } from '../../services/api';
import '../AllCss/EmailCarDetails.css';

function EmailCarDetails({ car, onClose }) {
  const [formData, setFormData] = useState({
    recipientEmail: '',
    senderName: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validation
    if (!formData.recipientEmail) {
      setError('Recipient email is required');
      setLoading(false);
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.recipientEmail)) {
      setError('Please enter a valid email address');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/api/cars/${car.id || car.stockNumber}/email`, {
        withCredentials: true,
        recipientEmail: formData.recipientEmail,
        senderName: formData.senderName || 'A friend',
        message: formData.message || '',
      });

      if (response.data.success) {
        setSuccess(true);
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        setError(response.data.message || 'Failed to send email');
      }
    } catch (err) {
      console.error('Error sending email:', err);
      setError(err.response?.data?.message || 'Failed to send email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="email-car-overlay" onClick={onClose}>
        <div className="email-car-modal" onClick={(e) => e.stopPropagation()}>
          <div className="email-car-success">
            <div className="email-car-success-icon">
              <Mail size={48} />
            </div>
            <h3>Email sent successfully!</h3>
            <p>The car details have been sent to {formData.recipientEmail}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="email-car-overlay" onClick={onClose}>
      <div className="email-car-modal" onClick={(e) => e.stopPropagation()}>
        <div className="email-car-header">
          <h3>Email Car Details</h3>
          <button className="email-car-close" onClick={onClose} aria-label="Close">
            <X size={20} />
          </button>
        </div>

        <div className="email-car-content">
          <div className="email-car-info">
            <h4>{car.year} {car.make} {car.model}</h4>
            <p className="email-car-price">
              {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(car.price)}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="email-car-form">
            <div className="email-car-field">
              <label htmlFor="recipientEmail">
                Recipient Email <span className="required">*</span>
              </label>
              <input
                type="email"
                id="recipientEmail"
                name="recipientEmail"
                value={formData.recipientEmail}
                onChange={handleChange}
                placeholder="friend@example.com"
                required
                disabled={loading}
              />
            </div>

            <div className="email-car-field">
              <label htmlFor="senderName">Your Name (Optional)</label>
              <input
                type="text"
                id="senderName"
                name="senderName"
                value={formData.senderName}
                onChange={handleChange}
                placeholder="Your name"
                disabled={loading}
              />
            </div>

            <div className="email-car-field">
              <label htmlFor="message">Personal Message (Optional)</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Add a personal note..."
                rows="4"
                disabled={loading}
              />
            </div>

            {error && (
              <div className="email-car-error">
                {error}
              </div>
            )}

            <div className="email-car-actions">
              <button
                type="button"
                className="email-car-cancel"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="email-car-submit"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Loader size={18} className="spinner" />
                    Sending...
                  </>
                ) : (
                  <>
                    <Send size={18} />
                    Send Email
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EmailCarDetails;

